var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHistory = function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67 26.824c-1.135.248-1.865 1.374-1.512 2.482a22.4 22.4 0 1 0 1.498-17.198c-.54 1.03-.016 2.266 1.06 2.706s2.296-.082 2.858-1.1a18.189 18.189 0 1 1-1.28 14.689c-.377-1.1-1.487-1.826-2.623-1.579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.884 31.683c.807-.82.807-2.15 0-2.97l-7.664-7.782v-7.529c0-1.16-.926-2.1-2.068-2.1s-2.067.94-2.067 2.1V21.8c0 .557.218 1.091.605 1.485l8.27 8.398c.807.82 2.116.82 2.924 0M.1 4.88c0-1.248 1.507-1.873 2.39-.99l10.619 10.616c.882.882.258 2.39-.99 2.39H1.5a1.4 1.4 0 0 1-1.4-1.4z"
  })));
};
export default SvgIconHistory;